export const alerts = {
  name: 'Alert |||| Alerts',
  
  fields: {
    alertType: 'Alert Type',
    severity: 'Severity',
    title: 'Title',
    message: 'Message',
    hotelId: 'Property',
    deviceId: 'Device',
    isSent: 'Sent',
    createdAt: 'Created At',
    sentAt: 'Sent At',
    context: 'Context',
  },
  
  status: {
    sent: 'Sent',
    pending: 'Pending',
  },
  
  severity: {
    info: 'Info',
    warning: 'Warning',
    critical: 'Critical',
  },
  
  filters: {
    alertType: 'Type',
    severity: 'Severity',
    dateFrom: 'From',
    dateTo: 'To',
    all: 'All',
    allTypes: 'All types',
    allSeverities: 'All',
    groupId: 'Group',
    hotelId: 'Property',
    allGroups: 'All groups',
    allHotels: 'All properties',
  },

  alertTypes: {
    DeviceOffline: 'Device Offline',
    HighErrorRate: 'High Critical Error Rate',
    DispenserMultipleErrors: 'Dispenser Critical Errors',
  },

  actions: {
    send: 'Send alert',
    sendAll: 'Send all pending',
  },

  messages: {
    sendSuccess: 'Alert sent successfully',
    sendError: 'The alert could not be sent',
  },
  
  tabs: {
    details: 'Details',
    context: 'Context',
  },

  show: {
    contextEmpty: 'No context data available.',
    notSentYet: 'Not sent yet',
    viewTechnicalData: 'View technical data',
    sections: {
      info: 'Alert Information',
      location: 'Location',
      timeline: 'Timeline',
      context: 'Context Data',
      contextSubtitle: 'Additional information related to this alert',
    },
    // Labels for known context keys (F-B-018): unmapped keys fall back to a
    // humanised version of the key itself (see AlertShow.tsx).
    contextFields: {
      device: 'Device',
      hotel: 'Property',
      section: 'Section',
      reason: 'Reason',
      timestamp: 'Timestamp',
    },
  },
};

export default alerts;